import {
  Chip,
} from '@mui/material';
import styled from 'styled-components';

const UserName = styled.p`
  margin-left: ${({ theme }) => theme.spacing(2)};
`;

const UserField = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const GroupChip = styled(Chip)`
  && {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;

export { UserField,
  UserName,
  GroupChip };
